import React from 'react';
import PropTypes from 'prop-types';
import { fetchDisciplines } from '../services/options_services';
import InputAsyncInformed from './InputAsyncInformed';

const DisciplineInputAsync = ({ params, ...props }) => (
  <InputAsyncInformed
    defaultOptions
    name={props.name}
    placeholder="Disciplina"
    loadOptions={(search) => fetchDisciplines({ search, ...params })}
    {...props}
  />
);

DisciplineInputAsync.propTypes = {
  params: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.number, PropTypes.object])
  ),
};

DisciplineInputAsync.defaultProps = {
  params: {},
};

export default DisciplineInputAsync;
